﻿import classNames from "classnames";
import { useContext } from "react";
import { AvisContext } from "../../context/AvisContext";

function AvisFooter() {
  const footerSectionClassName = classNames("avis-footer-section");
  const { getText } = useContext(AvisContext);
  return (
    <div className="avis-footer">
      <div className={footerSectionClassName}>{getText("portal_Footer_1")}</div>
      <div className={footerSectionClassName}></div>
      <div className={footerSectionClassName}>{getText("portal_Footer_2")}</div>
    </div>
  );
}

export default AvisFooter;
